// extracted by mini-css-extract-plugin
export default {"panel":"QkKoUebCAZViD5+SMh+gGA==","panelHeader":"_3gBrHJa0S6WBVqC84te6mA=="};